import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { login, logout } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js'
import {
  USER_DETAILS_RESET,
  USER_LOGIN_RESET
} from '../constants/userConstants.js'

// LoginScreen component handles user login functionality, including form submission, authentication, and redirection based on user roles and account status.
const LoginScreen = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const location = useLocation()
  const inputRef = useRef()

  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin

  // const redirect = location.search ? location.search.split('=')[1] : '/login'

  useEffect(() => {
    if (userInfo && userInfo.isDisabled === true) {
      navigate('/')
      alert('Your account has been disabled. Please contact the administrator.')
      dispatch({ type: USER_DETAILS_RESET })
      dispatch({ type: USER_LOGIN_RESET })
      dispatch(logout())
    }
  }, [userInfo, dispatch, navigate])

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      navigate('/dashboard')
    } else if (userInfo && userInfo.isDisabled === false) {
      navigate('/inventory')
    }
  }, [navigate, userInfo, dispatch])

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(login(email, password))
  }

  return (
    <FormContainer>
      <br />
      <h4>User Login</h4>
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group className='mb-3' controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            autoFocus
            autoComplete='email'
            ref={inputRef}
            type='email'
            placeholder='Enter email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-3' controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password (minimum 6 characters)'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        {/* </Form> */}

        <Row className='py-3 justify-content-center'>
          <Col>
            <Button type='submit' variant='outline-primary' className='my-3'>
              User Sign In
            </Button>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  )
}

export default LoginScreen
